// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {generateSelectionMap} from './get-lead-account-helper';
import {getLeadAccounts} from '../../../user/shared/repositories/lead-accounts';
import {readAudits} from './get-audits';

const getListOfSelectedDealers = selectedAccounts => Object.keys(selectedAccounts).filter(isSelected => selectedAccounts[isSelected]);

export const readLeadAccounts = racfId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const leadAccount = await getLeadAccounts(racfId);

            dispatch({
                leadAccount,
                type: actions.UPDATE_TCSM_AUDIT_LEAD_ACCOUNT
            });

            const initializedDealerHierarchy = generateSelectionMap(leadAccount);

            const selectedDealers = getListOfSelectedDealers(initializedDealerHierarchy.selectedAccounts);

            const facets = {
                dealers: selectedDealers,
                ...initializedDealerHierarchy
            };

            dispatch({
                facets,
                type: actions.UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET
            });

            dispatch({
                leadAccount,
                type: actions.UPDATE_TCSM_AUDIT_FILTERED_TERRITORIES
            });

            readAudits(selectedDealers, leadAccount)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/get-lead-accounts.js